export default __webpack_public_path__ + "static/media/logoE4MED.10076b40.png";